import React, {useEffect, useState, useRef} from 'react';
import pepsicoLogo from './../../../Assets/svgs/PepsiCo-Logo.svg';
import LogoutIcon from './../../../Assets/svgs/logoutIcon.svg';
import styles from './Header.module.css';
import {useLocation, useNavigate} from 'react-router-dom';
import {NEW_DAILOG} from '../../Constants';
import {useOktaAuth} from '@okta/okta-react';
import {ReactComponent as WhiteOpenSidebar} from './../../../Assets/svgs/whiteOpenSidebar.svg';

import {Button} from 'react-bootstrap';
import DWDModal from '../DWDModal/DWDModal';
import {PageItem, pageItems} from '../Sidebar/Sidebar';
import {callLogEvent} from '../../Util';

interface HeaderProps {
  centerTitle?: React.ReactNode;
  actions?: React.ReactNode;
  handleRecentQueries?: () => void;
  isExpandedHeader?: boolean;
}

const Header = ({ centerTitle, actions, handleRecentQueries, isExpandedHeader }: HeaderProps) => {
  const navigate = useNavigate();
  const {oktaAuth} = useOktaAuth();
  const [show, setShow] = useState<boolean>(false);
  const uaeMT = localStorage.getItem("DataSource") === "uae_mt" || localStorage.getItem("DataSource") === "ksa_mt";
  const firstHeaderTitle = uaeMT
    ? "Middle East Sales AI Assistant"
    : (centerTitle || "Dialogue with Data");

  const handleLOGO = async () => {
    callLogEvent(
      'CLICKED_ON_PEPSICO_LOGO',
      'Clicked on Pepsico logo to navigate back to NEW DAILOG'
    );
    navigate(NEW_DAILOG);
  };
  const sidebarRef = useRef<HTMLDivElement>(null);
  const toggleButtonRef = useRef<SVGSVGElement>(null);

  const handleLogout = async () => {
    oktaAuth.tokenManager.clear();
    oktaAuth.closeSession();
    sessionStorage.clear();
    localStorage.clear();
    await oktaAuth.signOut();
    console.log('You have been successfully logged out!');
    callLogEvent(
      'CLICKED_LOG_OUT_YES_BUTTON',
      'User opted logging off the application'
    );
  };

  const handleClose = () => {
    callLogEvent(
      'CLICKED_LOG_OUT_NO_BUTTON',
      'User opted out of logging off the application'
    );
    setShow(false);
  };

  const [isHovered, setIsHovered] = useState(true);
  const [pageDetails, setPagedetails] = useState<PageItem[]>(pageItems!);
  const location = useLocation();

  // For UAE/KSA second header: show all actions as-is (History, Generate, Return Home shown conditionally by UaeMtChatBotComponent)
  const secondHeaderActions: React.ReactNode = uaeMT ? actions : null;

  const navigateTo = (url: string, title?: string) => {
    if (title === 'Close') {
      setIsHovered(true);
    } else if (title === "Recent Queries") {
      handleRecentQueries?.();
      setIsHovered(true);
    } else {
      const latestPageDetails: PageItem[] = [...pageDetails];
      latestPageDetails.map((page) => {
        page.isActive = false;
        if (page.url === url) {
          page.isActive = true;
          return page;
        }
      });
      setPagedetails(latestPageDetails);
      navigate(url);
    }
  };

  useEffect(() => {
    navigateTo(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        !isHovered &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node) &&
        toggleButtonRef.current &&
        !toggleButtonRef.current.contains(event.target as Node)
      ) {
        setIsHovered(true);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isHovered]);

  return (
    <>
      {/* ── First header: original gradient header for ALL pages (unchanged) ── */}
      <div
        className={styles.container}
        style={isExpandedHeader && !uaeMT ? { height: '36px', alignItems: 'center', padding: '0 12px' } : undefined}
      >
        <div className={styles.peplogo}>
          <img
            src={pepsicoLogo}
            alt="PepsiCo Logo"
            onClick={handleLOGO}
            className="cursor-pointer"
            width={110}
            height={30}
            style={{ objectFit: "cover" }}
          />
        </div>
        <div className={styles.pepSidebarMobile}>
          <WhiteOpenSidebar
            height={"18px"}
            width={"18px"}
            onClick={() => setIsHovered(false)}
            ref={toggleButtonRef}
          />
          {!isHovered && (
            <div
              className={`${styles.sidebar} ${styles.expanded}`}
              ref={sidebarRef}
            >
              {pageDetails &&
                pageDetails.map((page, pageIndex) => {
                  return (
                    <div
                      key={pageIndex}
                      className={`${styles.sidebarItem} ${
                        page.isActive ? styles.sidebarItemActive : ""
                      }`}
                      onClick={() => navigateTo(page.url, page.Title)}
                    >
                      <span>
                        {page.Icon} <span className="f14px">{page.Title}</span>
                      </span>
                    </div>
                  );
                })}
            </div>
          )}
          <div className={styles.peplogoMobile}>
            <img
              src={pepsicoLogo}
              alt="PepsiCo Logo"
              onClick={handleLOGO}
              className="cursor-pointer"
              width={94}
              height={28}
              style={{ objectFit: "contain" }}
            />
          </div>
        </div>
        {/* For UAE/KSA show reference title in first header; detailed controls remain in second header */}
        <div className={styles.title}>
          {firstHeaderTitle}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {/* Actions only shown in first header for non-UAE/KSA pages */}
          {!uaeMT && actions}
          <Button
            className="emptyBtn"
            style={{ display: 'flex', alignItems: 'center', padding: '4px 6px' }}
            onClick={() => {
              callLogEvent(
                "CLICKED_LOG_OUT_BUTTON",
                "User clicked on the log out button to check logout options"
              );
              setShow(true);
            }}
          >
            <img src={LogoutIcon} alt="Logout ICon" className="imgSize25" />
          </Button>
        </div>
        <DWDModal
          show={show}
          handleClose={handleClose}
          handleShow={handleLogout}
          modalName={'logout'}
        />
      </div>

      {/* ── Second header: white bar, UAE/KSA ONLY ── */}
      {uaeMT && (
        <div className={styles.secondHeader}>
          <div className={styles.secondHeaderLeft}>{centerTitle}</div>
          <div className={styles.secondHeaderRight}>{secondHeaderActions}</div>
        </div>
      )}
    </>
  );
};

export default Header;
